import { render } from "./SubSecMenu.vue?vue&type=template&id=6144a65a&scoped=true"
import script from "./SubSecMenu.vue?vue&type=script&lang=js"
export * from "./SubSecMenu.vue?vue&type=script&lang=js"

import "./SubSecMenu.vue?vue&type=style&index=0&id=6144a65a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6144a65a"]])

export default __exports__